import React from 'react';
import Button from '@amzn/awsui-components-core/button';
import Input from '@amzn/awsui-components-core/input';
import SpaceBetween from '@amzn/awsui-components-core/space-between';
import TokenGroup from '@amzn/awsui-components-core/token-group';
import { useCustomReportValues } from 'src/components/star-grid/hooks/useCustomReportValues';
import { useStarGridText } from 'src/components/star-grid/hooks/useStarGridText';
interface Props {
  readonly values: readonly string[];
  readonly multiple: boolean;
  readonly disabled?: boolean;
  readonly testId: string;
  readonly onChange: (values: readonly string[]) => void;
}
export const CustomReportValues: React.FC<Props> = ({ values, multiple, disabled, testId, onChange }) => {
  const text = useStarGridText();
  const state = useCustomReportValues(values, multiple, onChange);
  return (
    <SpaceBetween size="xs">
      <SpaceBetween direction="horizontal" size="xs">
        <Input
          data-testid={`${testId}-input`}
          value={state.input}
          disabled={disabled}
          ariaLabel={text('templateEnterValue')}
          placeholder={text('templateEnterValue')}
          onChange={({ detail }) => state.setInput(detail.value)}
        />
        <Button data-testid={`${testId}-add`} formAction="none" disabled={disabled || !state.input.trim()} onClick={state.add}>
          {text('templateAddValue')}
        </Button>
      </SpaceBetween>
      <TokenGroup items={values.map((value) => ({ label: value }))} readOnly={disabled} onDismiss={({ detail }) => state.remove(detail.itemIndex)} />
    </SpaceBetween>
  );
};
